import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const ScreenshotLayout = styled.div<{ img?: any }>`
  width: 100%;
  aspect-ratio: 1232/600;

  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 32px;

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${({ img }) =>
    img &&
    `
    background-image: url(${img});
  `}

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    aspect-ratio: 912/445;
    border-radius: 24px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    aspect-ratio: 361/176;
    border-radius: 10px;
  }
`;
